// extracted by mini-css-extract-plugin
export default {"wrapper":"Q4u8_qb2emrotDV5WtAV","warningIcon":"ZilB1CeOXO_wrChMx_sD","usersTableWrapper":"y2Xh6pRs1THQD9aBqzSl"};